// TopBarV2 — thanh trên cùng của giao diện v2. DÙNG CHUNG SaaS + Core.
//
// Vì sao có component này: layout 2 tầng (rail 80px + nav phụ 240px + <main>) của CẢ HAI
// host đều KHÔNG có thanh trên cùng. Hệ quả đã ghi trong code SaaS
// (cnvwork-saas/admin/src/components/AppLayout.jsx: badge "Xuất file" phải đi mượn badge
// nhóm Tiện ích vì "layout SaaS không có thanh trên cùng"). Thanh này trả nó về đúng chỗ,
// và là nơi đặt logo + breadcrumb nên rail bỏ được ô logo (đỡ lặp 2 lần góc trên-trái).
//
// Đây là VỎ: nó không tự biết menu/quyền/badge của host. Host tính rồi truyền vào:
//   brand   {logo, appName, subtitle}
//   crumbs  [{label, path}] — hai host có getBreadcrumbs KHÁC SIGNATURE (cnv-ui nhận
//           (menu,path), Core nhận (path) vì menu là module-level) nên vỏ nhận sẵn mảng.
//   workspace— cụm ĐỔI WORKSPACE, đặt ngay sau tên app. Slot rỗng với Core: Core là bản
//           cài riêng cho MỘT khách, không có khái niệm nhiều workspace để đổi.
//   children— cụm bên phải (lối tắt, chọn ngôn ngữ, avatar…) tuỳ host.
//
// Breadcrumb BẤM ĐƯỢC (21/08): cả hai bản getBreadcrumbs đều đã trả kèm `path` (nhánh
// cha = item đầu của nhóm, nhánh con = path của chính item) nhưng vỏ trước đây in ra text
// chết — người dùng ở trang chi tiết (/crm/leads/<id>) không có đường nào quay lại danh
// sách ngoài việc bấm lại menu trái. Crumb nào KHÔNG có path thì vẫn in text như cũ.
//
// Ô tìm kiếm: phát KeyboardEvent ⌘K để CommandPalette (host đã mount sẵn, listener gắn ở
// window) tự mở → 0 dòng phụ thuộc vào host.
//
// Toàn bộ style ở src/styles/ui-v2.css mục 2 (.v2-topbar*), chỉ sống khi <html data-ui="v2">.

import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { tLabel } from '../../i18n/runtime.js';
import { useLingui } from '@lingui/react/macro';

function openCommandPalette() {
  // CommandPalette không export API mở — nó chỉ nghe keydown ở window.
  window.dispatchEvent(new KeyboardEvent('keydown', { key: 'k', metaKey: true, bubbles: true }));
}

export default function TopBarV2({ brand = {}, crumbs = [], workspace = null, children = null }) {
  const { t } = useLingui();
  const appName = brand.appName || 'CNV';

  const last = crumbs.length ? crumbs[crumbs.length - 1] : null;
  const parents = crumbs.slice(0, -1);

  return (
    <header className="v2-topbar">
      <div className="v2-topbar__brand">
        {brand.logo ? (
          <img src={brand.logo} alt="" className="v2-topbar__logo" />
        ) : null}
        <span className="v2-topbar__app">{appName}</span>
      </div>

      {workspace}

      <span className="v2-topbar__sep" aria-hidden="true" />

      <nav className="v2-topbar__crumb" aria-label={t`Đường dẫn trang`}>
        {parents.map((c, i) => (
          <span key={`${tLabel(c.label)}-${i}`} style={{ display: 'contents' }}>
            {c.path ? <Link to={c.path}>{tLabel(c.label)}</Link> : <span>{tLabel(c.label)}</span>}
            <i aria-hidden="true">/</i>
          </span>
        ))}
        {/* Nhánh cuối cũng bấm được: ở trang chi tiết (path thật là /crm/leads/<id>) nó trỏ
            về chính danh sách — đúng thứ người dùng muốn khi bấm tên trang đang mở. */}
        {last
          ? (last.path ? <Link to={last.path}><b>{tLabel(last.label)}</b></Link> : <b>{tLabel(last.label)}</b>)
          : <b>{brand.subtitle || ''}</b>}
      </nav>

      <button type="button" className="v2-topbar__search" onClick={openCommandPalette}>
        <Search size={14} />
        <span>{t`Tìm nhanh trong ${appName}`}</span>
        <kbd className="v2-topbar__kbd">⌘K</kbd>
      </button>

      {children}
    </header>
  );
}
